import { Dashboard as DashboardIcon } from '@mui/icons-material';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { OperationalView } from './components/OperationalView';

export const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={t('pages.dashboard.title')} />
      <Toolbar titleIcon={<DashboardIcon />} titleText={t('pages.dashboard.title')} />

      <PageContainer padding={false}>
        <OperationalView />
      </PageContainer>
    </>
  );
};
